//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "InfoComp",

  props: ["gateway", "scene"],

  data() {
    return {
      visible: false,
    }
  },

  methods: {
    show() {
      this.visible = true
    },

    hide() {
      this.visible = false

      // 清除自己
      this.remove()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/info/Info.vue